var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAxisIcon = function SvgAxisIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 12V7l1-1 2 2 6-6h-2l-4 4-2-2-2 2v6H7l-1-1 2-2-6-6v2l4 4-2 2 2 2h6m0 0v6l2 2 2-2 4 4h2l-6-6-2 2-1-1v-5h6l2 1-2 2 4 6v-2l-4-4 2-2-2-2h-6Z"
  })));
};
export default SvgAxisIcon;